module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "post-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "post-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "post-wrapper"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "post-title color-1-100 background-1-10-after"
  }, [_vm._v("\n      " + _vm._s(_vm.post.data.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.data.title),
      expression: "post.data.title"
    }],
    staticClass: "post-title",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Page title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.post.data.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.post.data, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.post.data.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "post-content",
    domProps: {
      "innerHTML": _vm._s(_vm.post.data.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('vue-editor', {
    staticClass: "post-content form-control form-control__editor",
    attrs: {
      "name": "content",
      "editorToolbar": _vm.editorToolbar,
      "data-vv-name": "Post content",
      "useCustomImageHandler": ""
    },
    on: {
      "imageAdded": _vm.handleImageAdded
    },
    model: {
      value: (_vm.post.data.content),
      callback: function($$v) {
        _vm.$set(_vm.post.data, "content", $$v)
      },
      expression: "post.data.content"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "post-modal"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h2', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "meta-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221f3dae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/PrivacyPolicy.vue
// module id = 954
// module chunks = 0